import { render, staticRenderFns } from "./CharityNumber.vue?vue&type=template&id=4772780c"
import script from "./CharityNumber.vue?vue&type=script&lang=js"
export * from "./CharityNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports